const DEFAULT_REDIRECT = "/dashboard";

const VALID_REDIRECT_PAGES = [
  "/",
  "/resume-builder",
  "/premium-subscription",
  "/resume-writing",
  "/upload-resume",
  "/referral",
  "/affiliate",
  "/select-experience",
  "/extension/connect",
  "/score-check",
  "/score-check/overall",
  "/score-check/personal",
  "/score-check/experience",
  "/score-check/education",
  "/score-check/skills",
  "/score-check/projects",
];

// Returns the validated post-login redirect destination.
// Falls back to /dashboard for unknown or unset paths.
// "/" redirects to /dashboard (no-op on homepage after login).
export const getRedirectPage = (currentPage: string | null): string => {
  if (!currentPage) return DEFAULT_REDIRECT;

  const basePath = currentPage.split("?")[0];

  if (VALID_REDIRECT_PAGES.includes(basePath)) {
    // Preserve query params for extension connect (nonce + extId must survive)
    if (basePath === "/extension/connect") return currentPage;
    return basePath === "/" ? DEFAULT_REDIRECT : basePath;
  }

  return DEFAULT_REDIRECT;
};
